<template>
  <VListItem
    key="notifications"
    link
    :to="{ name: 'notifications' }"
    :class="{ 'close' : miniVariant }"
    @click="$emit('itemSelect')"
  >
    <VListItemContent class="d-block">
      <VListItemTitle
        :class="miniVariant
          ? 'd-block' : 'd-flex align-center flex-row justify-start flex-nowrap'"
      >
        <div class="menu-icon menu-icon--relative">
          <img
            class="menu-icon__img"
            :src="notificationsIcon"
            :alt="$t('notifications')"
          >
          <span v-if="unreadCount > 0" class="menu-badge">
            {{ unreadCount }}
          </span>
        </div>
        {{ $t('notifications') }}
      </VListItemTitle>
    </VListItemContent>
  </VListItem>
</template>

<script>
import useSystemNotifications from '@/compositions/useSystemNotifications';

export default {
  name: 'TheMenuNotificationsLink',
  props: {
    miniVariant: Boolean,
  },
  setup() {
    const { unreadCount } = useSystemNotifications();

    return {
      unreadCount,
    };
  },
  computed: {
    notificationsIcon() {
      return require('@/assets/img/menu/notifications.svg');
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item {
  &::after {
    display: none;
  }
}

.v-list-item__content::v-deep {
  padding: 10px !important;
  @media screen and (max-width: 1650px) {
    padding: 5px !important;
  }
  @media screen and (max-width: 600px) {
    padding: 3px 12px 3px 12px !important;
    overflow: visible;
  }
  @media screen and (max-width: 320px) {
    padding: 0px 7px 0px 7px !important;
  }

  .v-list-item__title {
    font-size: 12px !important;
    @media screen and (max-width: 599px) {
      font-weight: 600;
      font-size: 20px !important;
      line-height: 100%;
      overflow: visible;
    }
    @media screen and (max-width: 320px) {
      font-size: 16px !important;
    }
    .menu-icon {
      @media screen and (max-width: 599px) {
        width: 18px;
      }
    }
  }
}

.menu-icon--relative {
  position: relative;
  overflow: visible;
}

.menu-icon__img {
  width: 24px;
  height: 24px;
  display: block;
}

.menu-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 14px;
  height: 14px;
  border-radius: 50px;
  background: #EA0D0D;
  color: #FFFFFF;
  font-size: 9px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
}

@media screen and (max-width: 599px) {
  .v-list-item {
    overflow: visible;
  }

  .menu-icon--relative {
    width: 24px !important;
    min-height: 24px;
    flex-shrink: 0;
    overflow: visible;
  }

  .menu-badge {
    top: 2px;
    right: -2px;
  }
}
</style>

<i18n locale="en" lang="yaml">
  notifications: Notifications
</i18n>

<i18n locale="ru" lang="yaml">
  notifications: Уведомления
</i18n>
